import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as httpStatusCodes from 'http-status-codes'
import get from 'lodash/get'
// import * as Sentry from '@sentry/node'

import fetchStatistics from '../../../service/job/fetch-statistics/fetchStatistics'
import {
  FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS,
  PUBLISH_JOB_FROM_ERROR_WIDGET,
  storeFetchedStatisticsOfRecentlyPostedJobs,
} from '../../actions/dashboard/dashboard'
import submitDraft from '../../../service/draft/submit-draft/submitDraft'
import { showDialog } from '../../actions/ui/ui'
import type {
  FetchJobsStatisticsOfRecentlyPostedJobsAction,
  PublishJobFromErrorWidgetAction,
} from '../../actions/dashboard/dashboard'
import type { JobsStatistics } from '../../reducers/jobs/jobs'

export function* fetchStatisticsOfRecentlyPostedJobsSaga(
  action: FetchJobsStatisticsOfRecentlyPostedJobsAction,
) {
  try {
    const statistics: JobsStatistics = yield call(fetchStatistics, action.payload)
    yield put(storeFetchedStatisticsOfRecentlyPostedJobs(statistics))
  } catch (error) {
    // Sentry.captureException(error)
  }
}

export function* publishJobFromErrorWidgetSaga(
  action: PublishJobFromErrorWidgetAction,
) {
  const jobId = action.payload
  try {
    if (!jobId) {
      throw new Error('publish Job From ErrorWidget with no id.')
    }
    const response = yield call(submitDraft, jobId)
    if (get(response, 'status') !== httpStatusCodes.ACCEPTED) {
      yield put(showDialog({
        title: 'Er ging iets mis',
        content: 'Onverwachte serverreactie ontvangen.',
      }))
    }
  } catch (error) {
    // Sentry.captureException(error)
    yield put(showDialog({
      title: 'Er ging iets mis',
      content: 'Conceptindiening is mislukt.',
    }))
  }
}

export default function* saga() {
  yield all([
    takeLatest(FETCH_STATISTICS_OF_RECENTLY_POSTED_JOBS, fetchStatisticsOfRecentlyPostedJobsSaga),
    takeLatest(PUBLISH_JOB_FROM_ERROR_WIDGET, publishJobFromErrorWidgetSaga),
  ])
}
